export default __webpack_public_path__ + "static/media/gallery_10.239f8014.jpg";